export const faqs = [
  {
    id: 'incluso',
    question: 'O que está incluso no projeto?',
    answer:
      'Design, desenvolvimento, responsividade mobile-first, SEO técnico básico, integração com WhatsApp ou formulário e suporte durante a entrega. Você recebe tudo pronto para colocar no ar.',
  },
  {
    id: 'hospedagem',
    question: 'Hospedagem e domínio estão inclusos?',
    answer:
      'Não. Hospedagem e domínio são contratados separadamente, com fornecedores de sua escolha. Indicamos parceiros confiáveis, mas a decisão e o custo ficam por sua conta — sem surpresas.',
  },
  {
    id: 'pagamento',
    question: 'Como funciona o modelo "pague quanto achar justo"?',
    answer:
      'Após a entrega, você avalia o resultado e nos informa o valor que considera justo pagar. Pagamento único, via Pix ou transferência. Sem tabela fixa.',
  },
  {
    id: 'prazo',
    question: 'Qual é o prazo de entrega?',
    answer:
      'Landing pages: 7 dias úteis. Sites institucionais: 15 a 20 dias úteis. Prazos iniciam após a aprovação do briefing.',
  },
  {
    id: 'revisoes',
    question: 'Posso pedir alterações depois?',
    answer:
      'Sim. Você tem direito a duas rodadas de revisão incluídas no projeto. Alterações fora desse escopo podem ser combinadas como evolução.',
  },
  {
    id: 'tecnologias',
    question: 'Quais tecnologias vocês utilizam?',
    answer:
      'React 18, Vite, HTML semântico, CSS moderno e bibliotecas enxutas. Performance, acessibilidade e SEO são prioridades desde o primeiro commit.',
  },
  {
    id: 'manutencao',
    question: 'Vocês cuidam da manutenção depois?',
    answer:
      'Após a entrega, pequenos ajustes podem ser combinados como serviço avulso. Também podemos seguir como parceiros de evolução contínua.',
  },
  {
    id: 'garantia',
    question: 'E se eu não gostar do resultado?',
    answer:
      'Trabalhamos com duas rodadas de revisão justamente para garantir alinhamento. Caso ainda não faça sentido, devolvemos o projeto sem custos.',
  },
];